import { Outlet } from 'react-router-dom'

/** Every signed-in expert can review. Layout enforces expert authentication. */
export function RequireReviewer() { return <Outlet /> }
